if (window.location.pathname === "/soplado/periodo" || window.location.pathname === "/zona-trabajo") {

    document.addEventListener('click', function (e) {
        const btnModalEliminar = e.target.closest('#btnEliminarProduccionSoplado');
        if (!btnModalEliminar) return;

        const formEditar = document.querySelector("#formEditarProduccionSoplado");
        const formEliminar = document.querySelector("#formEliminarProduccionSoplado");

        if (!formEditar || !formEliminar) return;

        const inputLineaEditar = formEditar.querySelector("#idLineaProduccionSoplado");
        const inputReporteEditar = formEditar.querySelector("#idEncabezadoReporteSoplado");

        const inputLineaEliminar = formEliminar.querySelector("#idLineaProduccionSoplado");
        const inputReporteEliminar = formEliminar.querySelector("#idEncabezadoReporteSoplado");

        if (!inputLineaEditar || !inputReporteEditar || !inputLineaEliminar || !inputReporteEliminar) {
            lanzarAlerta("Faltan datos para eliminar el registro.", "alerta-roja");
            return;
        }

        inputLineaEliminar.value = inputLineaEditar.value || "";
        inputReporteEliminar.value = inputReporteEditar.value || "";
    });


    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formEliminarProduccionSoplado') return;

        const botonActivo = e.submitter;

        if (!botonActivo || botonActivo.id !== 'btnEliminarProduccionSoplado') {
            return;
        }

        e.preventDefault();

        const formulario = e.target;
        const modalEditarProduccion = document.querySelector("#modalEditarProduccionSoplado");
        const modalPadre = formulario.closest('.modal');
        const spinner = formulario.querySelector('#spinner');
        const btnEliminar = formulario.querySelector('#btnEliminarProduccionSoplado');

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnEliminar) btnEliminar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/soplado/eliminar-produccion', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json = null;

            try {
                json = await respuesta.json();
            } catch (errorJson) {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok) {
                console.error('Error HTTP:', respuesta.status, json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Error al procesar la eliminación.', 'alerta-roja');
                } else {
                    alert('Error al procesar la eliminación.');
                }

                return;
            }

            if (!json || !json.result) {
                console.error('Respuesta inesperada:', json);

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Respuesta inesperada del servidor.', 'alerta-roja');
                }

                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(
                                error.mensaje || 'Error de validación.',
                                error.clase || 'alerta-roja'
                            );
                        }

                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }

                return;
            }

            const idReporteInput = formulario.querySelector('#idEncabezadoReporteSoplado');
            const idReporte = idReporteInput ? idReporteInput.value : '';

            const params = new URLSearchParams(window.location.search);
            const mes = params.get("mes");
            const anio = params.get("año");

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalEditarProduccion) modalEditarProduccion.classList.remove('modal--show');

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Registro eliminado con éxito.", "alerta-verde");
            }

            if (typeof window.actualizarModalReporteSoplado === 'function' && idReporte) {
                window.actualizarModalReporteSoplado(idReporte);
            }

            if (typeof window.actualizarTableroSopladoPeriodo === 'function') {
                window.actualizarTableroSopladoPeriodo(mes, anio);
            }

            if (typeof window.actualizarTablaSopladoPeriodo === 'function') {
                window.actualizarTablaSopladoPeriodo(mes, anio);
            }
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }

        } catch (error) {
            console.error("Error:", error);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Error crítico al procesar la solicitud.", "alerta-roja");
            } else {
                alert("Error crítico al procesar la solicitud.");
            }

        } finally {
            if (btnEliminar) btnEliminar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}